import { stripHtml } from "string-strip-html"

export const safeHtml = (html) => {
  const res = stripHtml(html, {
    ignoreTags: [
      "a",
      "article",
      "figcaption",
      "bdi",
      "datalist",
      "details",
      "abbr",
      "aside",
      "figure",
      "data",
      "keygen",
      "menuitem",
      "acronym",
      "footer",
      "mark",
      "meter",
      "summary",
      "address",
      "header",
      "rp",
      "output",
      "area",
      "main",
      "rt",
      "progress",
      "b",
      "nav",
      "ruby",
      "big",
      "section",
      "time",
      "blockquote",
      "wbr",
      "br",
      "button",
      "caption",
      "center",
      "cite",
      "col",
      "colgroup",
      "dd",
      "del",
      "dfn",
      "dir",
      "div",
      "dl",
      "dt",
      "em",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hr",
      "i",
      "ins",
      "kbd",
      "legend",
      "li",
      "map",
      "menu",
      "ol",
      "p",
      "pre",
      "q",
      "s",
      "samp",
      "select",
      "small",
      "span",
      "strike",
      "strong",
      "sub",
      "sup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr",
      "tt",
      "u",
      "ul",
      "var",
    ],
  }).result

  // remove all html attrs
  const regex = /<(\w+)\s+[^>]+>/gs

  return res.replace(regex, "<$1>")
}
